import { z } from 'zod';

export const DEFAULT_CURRENCY = 'GBP';

export const ORDER_TYPE_LABELS: Record<number, string> = {
  1: 'Dine-In',
  2: 'Delivery',
  3: 'Pick Up',
  4: 'Table',
};

export const DAYS_LIST = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
];

export const moneySchema = z.object({
  value: z.number(),
  currency: z.string(),
  _id: z.string().optional(),
});

export const availabilityRuleSchema = z.object({
  days: z.array(z.string()),
  from: z.string(),
  to: z.string(),
});

export type TMoney = z.infer<typeof moneySchema>;
export type TAvailabilityRule = z.infer<typeof availabilityRuleSchema>;
